import { Box } from '@mui/material';
import React from 'react';

import GlobalSearcher from '../../common/GlobalSearcher';

export type PageHeaderGlobalSearcherProps = React.ComponentProps<
  typeof GlobalSearcher
>;

const PageHeaderGlobalSearcher: React.FC<PageHeaderGlobalSearcherProps> = (
  props,
) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 40,
        marginLeft: 1,
      }}
    >
      <GlobalSearcher {...props} />
    </Box>
  );
};

export default PageHeaderGlobalSearcher;
